<template>
    <modal :visible.sync="isShowDialog" :title="$t('integration.handle')"  width="500px" @close="close">
        <el-tabs type='card' v-model='tab' :stretch="true">
          <el-tab-pane :label="$t('integration.handle')" name='Handle'></el-tab-pane>
          <el-tab-pane :label="$t('integration.ir_processing_records')" name='HandleRecord'></el-tab-pane>
        </el-tabs>
        <component :is='tab' :exId='exId' :detail="exDetail" ref='records' @close="close"></component>
    </modal>
</template>
<script>
import Handle from './Handle.vue'
import HandleRecord from './HandleRecord.vue'

export default {
  name: 'HandleDialog',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    exId: {
      type: String,
      default: false,
    },
    exDetail: {
      type: Array | Object,
      default: () => {}
    }
  },
  components: {
    HandleRecord,
    Handle
  },
  data () {
    return {
      tab: 'Handle',

    }
  },
  computed: {
    isShowDialog: {
      get: function () {
        return this.isShow
      },
      set: function (val) {
        this.$emit('update:isShow', val) // 可以优化成model  或者minx
      }
    },
  },
  watch: {
    isShowDialog(){
      if(this.isShowDialog){
      }
    }
  },
  methods: {
    close(){
      this.$emit('close')
    }
  }
}
</script>